<template>
<section class="termsBox">

    <h2 class="conTit1 mgt1">
        BMW ServiceCare+<br>
        POWER TRAIN WARRANTY<br> 
        서비스 제공을 위한 개인정보의 제공 동의<br>
    </h2>

    <div class="termsCon">
        <p>비엠더블유코리아㈜ 및 공식 딜러사(㈜내쇼날모터스, 도이치모터스㈜, ㈜동성모터스, ㈜바바리안모터스, ㈜삼천리모터스, 코오롱모터스㈜, ㈜한독모터스. 이하 “공식 딜러사”라고 합니다)는 BMW ServiceCare+  POWER TRAIN WARRANTY 서비스 제공을 위해 &lt;개인정보 보호법&gt; 등 관련 법률에 따라 아래와 같이 개인정보를 제공하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정하여 주시기 바랍니다.</p>
    </div>

    <div>
        <div class="termsCon" id="termsPart1">
            <ol class="circleNum contentBox">
                <li>
                    제공받는 자
                    <ol class="numList">
                        <li class="sizeUpBold">- 비엠더블유인슈어런스서비스코리아㈜, 한화손해보험㈜</li>
                    </ol>
                </li>
                <li>
                    제공목적
                    <ol class="numList">
                        <li class="sizeUpBold">- 보험 서비스 청약 및 제공을 위한 본인 확인</li>
                        <li class="sizeUpBold">- 보험 서비스 청약에 따른 의무 이행</li>
                        <li class="sizeUpBold">- 분쟁 처리 및 불법/부정이용 방지</li>
                    </ol>
                </li>
                <li>
                    처리항목
                    <ol class="numList">
                        <li>- 이름,  휴대전화번호, 전자우편주소, 주소, 차량정보(차대번호, 차량번호), 정비 이력</li>
                    </ol>
                </li>
                <li>
                    보유기간
                    <ol class="numList">
                        <li class="sizeUpBold">- 목적 달성 시까지</li>
                    </ol>
                </li>

                <div class="contentBoxBottom">
                    위의 개인정보 제공에 대한 동의를 거부할 수 있으며, 동의한 이후에도 언제든지 이를 철회할 수 있습니다. 그러나 동의를 거부할 경우 위에 나열된 처리목적에 해당하는 보험 서비스 제공이 제한될 수 있습니다.
                </div>
            </ol>
        </div>
    </div>

</section>
</template>

<script>
export default {
    name: 'TermInsuranceMarketing'
}
</script>

<style lang="scss" scoped>
</style>